export default __webpack_public_path__ + "static/media/ASR_UDS_DEGISIM_TURU.f66dc476.xlsx";